import { useQuery } from '@tanstack/react-query';

import { getWorkflowList } from '@/services/workflow/get-workflow-list';
import { useOrgStore } from '@/stores/org-store';
import type { WorkflowDetails } from '@/types/workflow-types';

export interface WorkflowListData {
  workflows: WorkflowDetails[];
  isWorkflowAdmin: boolean;
}

export function useWorkflowList(enabled = true) {
  const currentOrg = useOrgStore((s) => s.currentOrg);
  const orgId = currentOrg?.orgid;

  return useQuery<WorkflowListData>({
    queryKey: ['workflow-list', orgId],
    queryFn: async ({ signal }) => {
      const response = await getWorkflowList(orgId!, signal);
      return {
        workflows: response.data?.workflows ?? [],
        isWorkflowAdmin: response.data?.is_workflow_admin ?? false,
      };
    },
    enabled: !!orgId && enabled,
    staleTime: 30_000,
  });
}
